/* eslint-disable no-multi-spaces */
// import _ from 'lodash';
import React, { useState, useReducer } from 'react';
import { dateFns } from '../DateFnsUtils';
import { Button, ControlLabel, Modal, DatePicker, Form, FormGroup, FormControl, RadioGroup, Radio, SelectPicker, Uploader } from 'rsuite';

export default function DialogForm ({ title, schema, defaults = {}, show, onValidate, onSubmit, onCancel }) {
    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useReducer((state, update) => {
        return { ...state, ...update };
    }, {});

    const [data, setData] = useReducer((state, update) => {
        Object.keys(update).map(key => setErrors({ [key]: '' }));   // Clear errors for modifyed properties
        return { ...state, ...update };                             // Append changes to state
    }, defaults);

    async function submit () {
        const errors = await onValidate(data);

        if (Object.entries(errors).length) {
            return setErrors(errors);
        }

        setLoading(true);

        await onSubmit(data);

        setLoading(false);
    }

    function cancel () {
        onCancel();
        setData(defaults);
        setErrors(defaults);
    }

    const fields = schema.map((field, index) => {
        const key = `field-${index}`;

        if (field.type === 'date') {
            return (
                <FormGroup key={key}>
                    <ControlLabel htmlFor={field.name}>{field.label}</ControlLabel>
                    <FormControl
                        accepter={DatePicker}
                        block oneTap size='md'
                        id={field.name}
                        name={field.name}
                        renderValue={(value) => `${dateFns.format(value, 'dd/MM/y')}`}
                        onChange={value => setData({ [field.name]: value })}
                        errorMessage={errors[field.name]}
                    />
                </FormGroup>
            );
        }

        if (field.type === 'radio') {
            return (
                <FormGroup key={key}>
                    <ControlLabel htmlFor={field.name}>{field.label}</ControlLabel>
                    <FormControl
                        accepter={RadioGroup}
                        inline
                        id={field.name}
                        onChange={value => setData({ [field.name]: value })}
                        errorMessage={errors[field.name]}
                    >
                        {field.options.map((option, index) => (
                            <Radio key={`input-${field.name}-option-${index}`} name={field.name} value={option.value}>{option.label}</Radio>
                        ))}
                    </FormControl>
                </FormGroup>
            );
        }

        if (field.type === 'select') {
            return (
                <FormGroup key={key}>
                    <ControlLabel htmlFor={field.name}>{field.label}</ControlLabel>
                    <FormControl
                        accepter={SelectPicker}
                        id={field.name}
                        onChange={value => setData({ [field.name]: value })}
                        data={field.options}
                        errorMessage={errors[field.name]}
                        block
                    />
                </FormGroup>
            );
        }

        if (field.type === 'file') {
            return (
                <FormGroup key={key}>
                    <ControlLabel htmlFor={field.name}>{field.label}</ControlLabel>
                    <FormControl
                        accepter={Uploader}
                        id={field.name}
                        autoUpload={false}
                        errorMessage={errors[field.name]}
                        onRemove={file => setData({ [field.name]: data[field.name].filter(item => file.name !== item.name) })}
                        onChange={files => setData({ [field.name]: files })}
                        multiple
                    >
                        <div>Haga Click para cargar sus archivos</div>
                    </FormControl>
                </FormGroup>
            );
        }

        return (
            <FormGroup key={key}>
                <ControlLabel htmlFor={field.name}>{field.label}</ControlLabel>
                <FormControl
                    id={field.name}
                    name={field.name}
                    onChange={value => setData({ [field.name]: value })}
                    errorMessage={errors[field.name]}
                />
            </FormGroup>
        );
    });

    return (
        <Modal show={show} onHide={cancel}>
            <Modal.Header closeButton>
                <Modal.Title id='seller-create-modal'>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ marginRight: '-15px', paddingRight: '15px' }}>
                <Form fluid id="form" onSubmit={submit}>
                    {fields}
                </Form>
            </Modal.Body>
            <div className="flex justify-right mt-4">
                <Button type="submit" form="form" appearance='primary' loading={loading}>Aceptar</Button>
                <Button appearance='subtle' disabled={loading} onClick={cancel}>Cancelar</Button>
            </div>
        </Modal>
    );
};
